module.exports = __webpack_public_path__ + "static/thank-you-afd92cccfc1af9aa01f374ea607fc2e6.png";